module.exports = __webpack_public_path__ + "img/phoneEle.94cdaf9d.svg";